import {
  DEFAULT_ANCHOR_BY_TYPE,
  ElementState,
  ElementType,
  THICKNESS_PRESETS,
  Trapezoid,
} from '@ritabygglov/core';

export const computeTrapezoidVertices = (
  topWidth: number,
  bottomWidth: number,
  height: number
): { vertices: [number, number][]; width: number } | null => {
  const absTop = Math.abs(topWidth);
  const absBottom = Math.abs(bottomWidth);
  const absHeight = Math.abs(height);

  if (absTop === 0 || absBottom === 0 || absHeight === 0) {
    return null;
  }

  const maxWidth = Math.max(absTop, absBottom);
  const bottomOffset = (maxWidth - absBottom) / 2;
  const topOffset = (maxWidth - absTop) / 2;

  const xSign = topWidth < 0 ? -1 : 1;
  const ySign = height < 0 ? -1 : 1;

  const vertices: [number, number][] = [
    [bottomOffset * xSign, absHeight * ySign],
    [(bottomOffset + absBottom) * xSign, absHeight * ySign],
    [(topOffset + absTop) * xSign, 0],
    [topOffset * xSign, 0],
  ];

  return { vertices, width: maxWidth * xSign };
};

export const createTrapezoid = (
  initialX: number,
  initialY: number,
  renderingOrder: number,
  id: string,
  userId: string
): Trapezoid => {
  const topWidth = 100;
  const bottomWidth = 150;
  const height = 80;
  const computed = computeTrapezoidVertices(topWidth, bottomWidth, height)!;

  return {
    id,
    type: ElementType.Trapezoid,
    text: ' ',
    topWidth,
    bottomWidth,
    height,
    x: initialX,
    y: initialY,
    width: computed.width,
    state: ElementState.Creation,
    rotate: 0,
    renderingOrder,
    style: {
      fill: 'transparent',
      stroke: '#000',
    },
    thickness: THICKNESS_PRESETS.M,
    thicknessAnchor: DEFAULT_ANCHOR_BY_TYPE[ElementType.Trapezoid],
    userVersion: {
      userId,
      version: 1,
    },
    showDimensions: false,
    diagonalHatch: false,
  };
};
